const STATUSES_TRANSLATE = {
    INITIAL: 'Заполнение заявки',
    WAITING_SIGN_AGREEMENTS_BY_DIGITAL_SIGNATURE: 'Ожидает подписи соглашений с помощью ЭЦП',
    ON_AUTO_VERIFICATION: 'На рассмотрении',
    MANUAL_VERIFICATION: 'На рассмотрении',
    ON_MANUAL_VERIFICATION: 'На рассмотрении',
    BACK_TO_REVISION: 'На рассмотрении',
    REVISED_VERIFICATION: 'На рассмотрении',
    REJECTED: 'Отказано',
    APPROVED: 'Заявка принята',
    APPROVED_WAITING_SEND_TO_SIGN_CONTRACT_BY_PHYSICAL_SIGNATURE: 'Ожидает курьера',
    APPROVED_WAITING_SIGN_CONTRACT_BY_PHYSICAL_SIGNATURE: 'Ожидает курьера',
    APPROVED_SIGNED_CONTRACT_BY_PHYSICAL_SIGNATURE: 'Ожидает курьера',
    APPROVED_WAITING_SEND_TO_SIGN_CONTRACT_BY_DIGITAL_SIGNATURE: 'На рассмотрении',
    APPROVED_WAITING_SIGN_CONTRACT_BY_DIGITAL_SIGNATURE: 'На рассмотрении',
    CANCELED: 'Заявка аннулирована',
    AGREED: 'На рассмотрении',
    REMITTANCE_PREPARED: 'На рассмотрении',
    REMITTANCE_IN_PROGRESS: 'Одобрено',
    REMITTANCE_ERROR: 'Отказано',
    REMITTANCE_CANCELED: 'Отказано',
    REMITTANCE_PAID: 'Одобрено',
    ACTIVE: 'Заем активен',
    WAITING_PROLONGATION_OFFERT: 'Заявка на продление (оферта не подписана)',
    WAITING_PROLONGATION_PRC_PAYMENT: 'Заявка на пролонгацию (% не оплачены)',
    WAITING_PROLONGATION: 'Условия продления выполнены',
    PROLONGED: 'Активен (продлен)',
    EXPIRED: 'Заем просрочен',
    CALCULATION_STOPPED: 'Просрочен',
    WAITING_RESTRUCTURING: 'Заявка на реструктуризацию',
    RESTRUCTURED: 'Реструктуризирован',
    RESTRUCTURED_EXPIRED: 'Реструктуризирован (просрочен)',
    ANNULLED: 'Отказано',
    AOT_PAYMENT_AWAITING: 'Ожидание платежа досрочного гашения',
    FINISHED: 'Заем погашен'
};

function translateStatus(status) {
    if( STATUSES_TRANSLATE[status] !== ''){
        return STATUSES_TRANSLATE[status]
    }else{
        return 'Неизвестный статус заявки';
    }
}

export default {
    translateStatus
}